import React, { Component } from "react";
import Predefine_2_Cricket from "../components/Predefine_2_Cricket/Predefine_2_Cricket";

export class Predefine_2_CricketPage extends Component {
  render() {
    return <Predefine_2_Cricket />;
  }
}

export default Predefine_2_CricketPage;
